import { TaskTemplateRecord } from './types';

/** True when the selected task template runs the ATS acknowledge task. */
export const isAcknowledgeTaskTemplate = (
  taskTemplate: TaskTemplateRecord | null | undefined,
): boolean => {

  if (!taskTemplate) return false;

  const nestedTasks = taskTemplate.tasks?.flat() || [];
  if (nestedTasks.some((task) => task.taskName === 'acknowledge')) return true;

  return /acknowledge/i.test(taskTemplate.templateName || '');

};
